export { default } from './AllergyDetailsPopup';
